import { Download, X } from 'lucide-react'
import { Button } from '@/components/ui'
import { useInstallPrompt } from '@/hooks'

export function InstallPrompt() {
  const { isInstallable, install, dismiss } = useInstallPrompt()

  if (!isInstallable) {
    return null
  }

  const handleInstall = async () => {
    await install()
  }

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80
                 bg-card border border-border rounded-lg p-4 shadow-lg z-40"
      role="dialog"
      aria-labelledby="install-prompt-title"
      aria-describedby="install-prompt-description"
    >
      <button
        onClick={dismiss}
        className="absolute top-2 right-2 text-muted-foreground hover:text-foreground transition-colors"
        aria-label="Dismiss install prompt"
      >
        <X className="h-4 w-4" />
      </button>

      <div className="flex items-start gap-3 pr-6">
        <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
          <Download className="h-6 w-6 text-primary" />
        </div>
        <div>
          <h3 id="install-prompt-title" className="font-medium text-sm">
            Install CA Copilot
          </h3>
          <p
            id="install-prompt-description"
            className="text-xs text-muted-foreground mt-1"
          >
            Get quick access with offline support.
          </p>
        </div>
      </div>

      <div className="flex gap-2 mt-4">
        <Button variant="outline" size="sm" onClick={dismiss} className="flex-1">
          Not now
        </Button>
        <Button size="sm" onClick={handleInstall} className="flex-1">
          Install
        </Button>
      </div>
    </div>
  )
}
